import React from 'react';

import moment from 'moment';

import {
  ActionsRequisesDtoActionsRequisesEnum,
  DossierSummaryResponseDto,
} from 'lib_api/lib/api/gen/api';

import {
  ColumnProps,
  TableHeaderFunction,
} from 'components/WrappedComponents/Table/types';
import { buildActionsRequisesContent } from 'utils/actionsRequisesUtils';
import { classementEnumMapping } from 'utils/enumData';
import { DATE_FORMAT } from 'utils/formats';
import {
  buildImmatriculationContent,
  buildStatutContent,
} from 'utils/TableUtils';

import DashboardHeader from '../DashboardHeader';
import { FilterDashboardAutoriteFourriere } from '../DashboardHeader/Filters/types';
import { AutoriteFourriereSortOptions } from '../types';

export function buildColumns(
  url: string,
  afActionsRequises: ActionsRequisesDtoActionsRequisesEnum[] | undefined,
): ColumnProps<DossierSummaryResponseDto, AutoriteFourriereSortOptions>[] {
  return [
    {
      title: 'Immatriculation',
      sortedField: AutoriteFourriereSortOptions.IMMATRICULATION,
      buildCellContent: data => buildImmatriculationContent(url, data),
    },
    {
      title: 'Date de mise en fourrière',
      sortedField: AutoriteFourriereSortOptions.DATE_MISE_FOURRIERE,
      buildCellContent: data =>
        data.ficheFourriere !== null &&
        data.ficheFourriere.dateMiseEnFourriere !== null
          ? moment(data.ficheFourriere.dateMiseEnFourriere).format(DATE_FORMAT)
          : null,
    },
    {
      title: 'Nature de mise en fourrière',
      sortedField: AutoriteFourriereSortOptions.NATURE_MISE_EN_FOURRIERE,
      buildCellContent: data =>
        data.computed !== null && data.computed.brancheDto !== null
          ? data.computed.brancheDto.nature
          : null,
    },
    {
      title: 'Statut',
      sortedField: AutoriteFourriereSortOptions.STATUT,
      buildCellContent: buildStatutContent,
    },
    {
      title: 'Classement',
      sortedField: AutoriteFourriereSortOptions.CLASSEMENT,
      buildCellContent: data =>
        data.traitement && data.traitement.classement
          ? classementEnumMapping[data.traitement.classement].label
          : null,
    },
    {
      title: "Date d'ordre de destruction",
      sortedField: AutoriteFourriereSortOptions.DATE_ORDRE_DESTRUCTION,
      buildCellContent: data =>
        data.traitement && data.traitement.dateOrdreDestruction
          ? moment(data.traitement.dateOrdreDestruction).format(DATE_FORMAT)
          : null,
    },
    {
      title: 'Date de sortie définitive',
      sortedField: AutoriteFourriereSortOptions.DATE_SORTIE_DEFINITIVE,
      buildCellContent: data =>
        data.sortie !== null && data.sortie.dateSortie !== null
          ? moment(data.sortie.dateSortie).format(DATE_FORMAT)
          : null,
    },
    {
      title: 'Fourrière',
      sortedField: AutoriteFourriereSortOptions.FOURRIERE,
      buildCellContent: data =>
        data.computed?.fourriereDto?.raisonSociale || null,
    },
    {
      title: 'Action requise',
      sortedField: AutoriteFourriereSortOptions.ACTIONS_REQUISES,
      buildCellContent: data =>
        buildActionsRequisesContent(url, data, afActionsRequises),
    },
  ];
}

export const buildHeader: TableHeaderFunction<
  DossierSummaryResponseDto,
  FilterDashboardAutoriteFourriere
> = (fetchedData, _selectedData, filter, setFilter, sort) => (
  <DashboardHeader
    totalResult={fetchedData?.total ?? 0}
    filter={filter}
    setFilter={setFilter}
    sort={sort}
  />
);
